







































































import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
import Form from '@/components/form-base';
import {Send, DialogForm, FormOverlay} from '@/components/bwaff';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'

export interface ListPickerItem {
  id: string;
  name: string;
}

@Component({
  components: {
    FormOverlay,
    DialogForm,
    HeaderButtons
  }
})
export default class ListPickerDialog extends Form {
  active: boolean = false;
  edit: boolean = true;
  search: string = '';

  @Prop()
  items: any[];

  @Prop()
  readArticleUrl: string;

  @Prop()
  title: string;

  @Prop({default: true})
  hasActions: boolean;

  @Prop({default: true})
  hasHelp: boolean;

  get contentСlass() {
    let result = ['template-select-dialog'];

    if(!this.hasActions) {
      result.push('template-select-dialog--hide-actions')
    }

    return result.join(' ');
  }

  activeItem: any = null;

  @Emit('update:activeItem')
  onUpdateActiveItem(value: any) {
    this.activeItem = value;
  }

  @Emit('confirm')
  onConfirm() {}

  get computedItems() {
    return this.items
      .filter((e: any) => e.name.toLowerCase().includes(this.search.toLowerCase()))
  };

  open() {
    this.activeItem = null;
    this.search = '';
    this.active = true;
  }

  close() {
    this.active = false;
  }

  get self() {
    return this;
  }
}
